import { createJSONStorage } from 'jotai/utils';

export const createLocalStorage = <T>() => createJSONStorage<T>(() => localStorage);
export const createSessionStorage = <T>() => createJSONStorage<T>(() => sessionStorage);
